export const formatYYYYMMDD = ({ date, delimiter = '-' }: { date: Date; delimiter?: string }) => {
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)

  const result = `${year}${delimiter}${month}${delimiter}${day}`

  return result
}

export const formatYYMMDD = (inputDate: string): string => {
  const date = new Date(inputDate)
  const year = date.getFullYear() % 100
  const month = date.getMonth() + 1
  const day = date.getDate()

  const formattedYear = year < 10 ? `0${year}` : `${year}`
  const formattedMonth = month < 10 ? `0${month}` : `${month}`
  const formattedDay = day < 10 ? `0${day}` : `${day}`

  return `${formattedYear}.${formattedMonth}.${formattedDay}`
}

export const formatYMDHMS = (inputDate: string): string => {
  const originalDate = new Date(inputDate)
  const formattedDate = originalDate
    .toISOString()
    .replace(/T|Z|\.\d{3}/g, ' ')
    .trim()

  return formattedDate
}

const DAY_OF_THE_WEEK = ['일', '월', '화', '수', '목', '금', '토']

export const formatYYMMDDDDD = ({ date, delimiter = '-' }: { date: Date; delimiter?: string }) => {
  const year = `${date.getFullYear()}`.slice(-2)
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  const dayOfTheWeek = DAY_OF_THE_WEEK[date.getDay()]

  const result = `${year}${delimiter}${month}${delimiter}${day}(${dayOfTheWeek})`

  return result
}
